import { render, staticRenderFns } from "./projektmanagement-6-4.vue?vue&type=template&id=504fbf7e&"
import script from "./projektmanagement-6-4.vue?vue&type=script&lang=js&"
export * from "./projektmanagement-6-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports